<template>
  <Modal
    :value="value"
    @hide="hide()"
    title="Application details"
    :subtitle="`${item.application.name} - ${item.application.version}`"
  >
    <template slot="body" class="content">
      <SearchBar
        v-model="tempFilter"
        :id="searchId"
        :selectOnSubmit="true"
        :loading="searching"
        :focus="true"
        @submit="search($event)"
      ></SearchBar>
      <table class="table is-hoverable is-fullwidth">
        <thead>
          <tr class="is-unselectable">
            <th>Name</th>
            <th>License</th>
            <th>Installed</th>
            <th>When</th>
          </tr>
        </thead>
        <tr
          v-for="item of filtered"
          :key="item.computer.name + item.application.key"
        >
          <td>
            <router-link
              :to="
                `/domains/${$route.params.domainUID}/computers/${item.computer.uid}/packages`
              "
              ng-click="Goto($event)"
            >
              {{ name(item.computer) }}
            </router-link>
          </td>

          <td>
            <span v-if="item.application.key && item.application.key !== ''">{{
              item.application.key
            }}</span>
            <span v-if="!item.application.key || item.application.key === ''">
              <i>No license</i>
            </span>
          </td>
          <td>
            <span class="icon">
              <i
                class="mdi"
                :class="{
                  'mdi-check has-text-success': item.application.installed,
                  'mdi-delete has-text-grey': !item.application.installed,
                }"
              ></i>
            </span>
          </td>
          <td>
            <span v-if="item.application.timeChanged">
              {{ date(item.application.timeChanged) }}
            </span>
            <span v-else>
              <i>Unknown</i>
            </span>
          </td>
        </tr>
      </table>
    </template>
    <template slot="footer" class="content">
      <div class="button" @click="hide()">Close</div>
    </template>
  </Modal>
</template>
<script>
import computerHelper from "@/utils/computer";
import { getId } from "@/utils/document";
import { toReadableDate } from "@/utils/date";

export default {
  props: {
    value: Boolean,
    item: Object,
  },
  components: {
    Modal: () => import("@/components/main/Modal.vue"),
    SearchBar: () => import("@/components/main/SearchBar.vue"),
  },
  computed: {
    date() {
      return (date) => {
        return toReadableDate(date);
      };
    },
    filtered() {
      if (this.filter && this.filter !== "") {
        return this.item.items.filter(
          (x) =>
            x.application.name.toLowerCase().includes(this.filter) ||
            x.application.version?.includes(this.filter) ||
            x.application.license?.toLowerCase().includes(this.filter)
        );
      } else return this.item.items;
    },
    name() {
      return (item) => {
        return computerHelper.getName(item);
      };
    },
  },
  data() {
    return {
      searching: false,
      tempFilter: "",
      filter: "",
      searchId: getId(),
    };
  },
  created() {},
  methods: {
    search(searchStr) {
      this.searching = true;

      searchStr = searchStr.trim().toLowerCase();
      this.filter = searchStr;

      this.searching = false;
    },

    hide() {
      this.$emit("hide", false);
      this.$emit("input", false);
    },
  },
};
</script>
